import React, { useState, useEffect } from 'react';
import { db, auth } from '../firebase';
import { collection, query, where, onSnapshot, doc, updateDoc, or } from 'firebase/firestore';

const DriverPage = () => {
    const [tumKargolar, setTumKargolar] = useState([]);
    const [filteredKargolar, setFilteredKargolar] = useState([]);
    const [aktifFiltre, setAktifFiltre] = useState("HAZIRLANACAK"); 
    const [searchQuery, setSearchQuery] = useState("");
    const [activeDeliveryId, setActiveDeliveryId] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        const user = auth.currentUser;
        if (!user) return;

        const q = query(
            collection(db, "kargolar"), 
            or(
                where("atananEmail", "==", user.email),
                where("durum", "==", "HAZIRLANACAK")
            )
        );

        const unsubscribe = onSnapshot(q, (snapshot) => {
            setTumKargolar(snapshot.docs.map(d => ({ id: d.id, ...d.data() })));
        });
        return () => unsubscribe();
    }, []);

    useEffect(() => {
        const filtered = tumKargolar.filter(k => {
            const matchesSearch = (k.adSoyad || "").toLowerCase().includes(searchQuery.toLowerCase()) || 
                                 (k.adres || "").toLowerCase().includes(searchQuery.toLowerCase());
            
            if (aktifFiltre === "HAZIRLANACAK") {
                return matchesSearch && (k.durum === "HAZIRLANACAK" || k.durum === "BEKLEYEN");
            }
            return matchesSearch && (aktifFiltre === "HEPSİ" || k.durum === aktifFiltre);
        });
        setFilteredKargolar(filtered);
    }, [searchQuery, aktifFiltre, tumKargolar]);

    // WHATSAPP MESAJ FONKSİYONU
    const whatsappMesajAt = (kargo) => {
        let temizNo = (kargo.tel || "").replace(/\s/g, '');
        if (temizNo.startsWith('0')) temizNo = temizNo.substring(1);
        const formatliNo = `+90${temizNo}`;

        const soforIsmi = auth.currentUser?.email.split('@')[0].toUpperCase();
        
        const mesaj = `Merhaba ${kargo.adSoyad}, Aydın Zeytinyağı'ndan verdiğiniz siparişinizi teslim etmek üzere bölgenizdeyim. Ben şoförünüz ${soforIsmi}. Müsaitlik durumunuzu bildirirseniz teslimat için geçeceğim. İyi günler dilerim.`;
        
        const wpUrl = `https://wa.me/${formatliNo.replace('+', '')}?text=${encodeURIComponent(mesaj)}`;
        window.open(wpUrl, '_blank');
    };

    const finishDelivery = async (tip) => {
        await updateDoc(doc(db, "kargolar", activeDeliveryId), { 
            durum: "TESLİM EDİLDİ", 
            tahsilatTipi: tip,
            teslimTarihi: new Date().toISOString(),
            teslimEdenSöför: auth.currentUser.email 
        });
        setIsModalOpen(false);
    };

    return (
        <div className="bg-slate-50 min-h-screen text-slate-900 pb-20 font-sans">
            <nav className="bg-white border-b p-4 flex justify-between items-center sticky top-0 z-20 shadow-sm">
                <h1 className="font-black text-green-700 text-lg uppercase tracking-tighter">DEVAY <span className="text-slate-400 font-light tracking-normal text-xs">LOJİSTİK</span></h1>
                <span className="text-[10px] bg-green-50 px-3 py-1 rounded-full text-green-700 font-black uppercase border border-green-100">{auth.currentUser?.email.split('@')[0]}</span>
            </nav>

            <div className="bg-white p-4 border-b sticky top-[61px] z-10 space-y-3 shadow-sm">
                <input type="text" placeholder="Müşteri veya bölge ara..." className="w-full p-4 bg-slate-100 rounded-2xl outline-none focus:ring-2 focus:ring-green-500 font-bold" onChange={(e) => setSearchQuery(e.target.value)} />
                <div className="flex gap-2 overflow-x-auto no-scrollbar pb-1">
                    {["HAZIRLANACAK", "BEKLEYEN", "TESLİM EDİLDİ", "EVDE YOK", "İADE", "HEPSİ"].map(f => (
                        <button key={f} onClick={() => setAktifFiltre(f)} className={`px-5 py-2 rounded-xl text-[10px] font-black border transition-all whitespace-nowrap ${aktifFiltre === f ? 'bg-green-700 text-white border-green-700 shadow-md shadow-green-100' : 'bg-white text-slate-400 border-slate-100'}`}>{f}</button>
                    ))}
                </div>
            </div>

            <div className="p-4">
                {filteredKargolar.length === 0 ? (
                    <p className="text-center text-slate-300 py-20 font-black uppercase text-[10px] tracking-[0.2em]">Kargo Bulunmuyor</p>
                ) : (
                    filteredKargolar.map(k => {
                        const isTeslimEdildi = k.durum === "TESLİM EDİLDİ";
                        const temizTel = (k.tel || "").replace(/\s/g, '');
                        const toplamTutar = Number(k.tutar || 0) + Number(k.kargoUcreti || 0);

                        return (
                            <div key={k.id} className="bg-white rounded-[2.5rem] p-6 shadow-sm border border-slate-100 mb-5 relative overflow-hidden">
                                <div className="flex justify-between items-start mb-4">
                                    <div>
                                        <h3 className="font-black text-lg text-slate-800 uppercase leading-none mb-1 tracking-tight">{k.adSoyad}</h3>
                                        <p className="text-[10px] font-bold text-blue-600 uppercase italic">{k.aciklama || 'Ürün Belirtilmemiş'}</p>
                                    </div>
                                    <span className={`text-[9px] px-3 py-1 rounded-full font-black text-white uppercase ${isTeslimEdildi ? 'bg-green-600' : 'bg-orange-500 shadow-lg shadow-orange-100'}`}>{k.durum || 'BEKLEYEN'}</span>
                                </div>

                                <p className="text-sm text-slate-500 mb-4 font-medium leading-snug">📍 {k.adres}</p>
                                
                                <div className="bg-slate-50 p-4 rounded-2xl mb-5 flex justify-between items-center border border-slate-100">
                                    <span className="text-[10px] font-black text-slate-400 uppercase tracking-widest">💰 Tahsilat</span>
                                    <span className="text-2xl font-black text-slate-900 tracking-tighter">{toplamTutar} TL</span>
                                </div>

                                <div className="grid grid-cols-3 gap-2 mb-4">
                                    <a href={`tel:${temizTel}`} className="bg-blue-600 text-white py-4 rounded-2xl font-black text-[10px] text-center shadow-lg shadow-blue-100 active:scale-95 transition-all">ARA</a>
                                    {/* WHATSAPP BUTONU GÜNCELLENDİ */}
                                    <button onClick={() => whatsappMesajAt(k)} className="bg-green-500 text-white py-4 rounded-2xl font-black text-[10px] text-center shadow-lg shadow-green-100 active:scale-95 transition-all">WP MESAJ</button>
                                    <a href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(k.adres)}`} target="_blank" rel="noreferrer" className="bg-slate-800 text-white py-4 rounded-2xl font-black text-[10px] text-center shadow-lg shadow-slate-200 active:scale-95 transition-all">KONUM</a>
                                </div>

                                <div className={`grid grid-cols-2 gap-2 ${isTeslimEdildi ? 'opacity-30 pointer-events-none grayscale' : ''}`}>
                                    <button onClick={() => {setActiveDeliveryId(k.id); setIsModalOpen(true);}} className="bg-green-600 text-white py-5 rounded-2xl font-black text-xs shadow-xl shadow-green-100 active:scale-95 transition-all">TESLİM ET</button>
                                    <button onClick={async () => { if(window.confirm("Evde yok olarak işaretlensin mi?")) await updateDoc(doc(db, "kargolar", k.id), {durum: "EVDE YOK"}); }} className="border-2 border-slate-100 text-slate-400 py-5 rounded-2xl font-black text-xs active:bg-slate-50 transition-all">EVDE YOK</button>
                                </div>
                            </div>
                        )
                    })
                )}
            </div>

            {isModalOpen && (
                <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[100] flex items-end justify-center p-4">
                    <div className="bg-white w-full max-w-sm rounded-t-[3rem] p-10 shadow-2xl animate-in slide-in-from-bottom duration-300">
                        <div className="w-12 h-1.5 bg-slate-200 rounded-full mx-auto mb-6"></div>
                        <h2 className="text-center font-black text-slate-800 mb-8 uppercase tracking-widest text-sm">Ödeme Tipi Seçin</h2>
                        <div className="space-y-3">
                            {["NAKİT", "KART", "IBAN"].map(tip => (
                                <button key={tip} onClick={() => finishDelivery(tip)} className="w-full bg-slate-50 p-5 rounded-2xl font-black text-slate-700 hover:bg-green-600 hover:text-white transition-all uppercase flex justify-center items-center gap-3 border border-slate-100">
                                    <span className="text-xl">{tip === 'NAKİT' ? '💵' : tip === 'KART' ? '💳' : '🏦'}</span> {tip}
                                </button>
                            ))}
                        </div>
                        <button onClick={() => setIsModalOpen(false)} className="w-full mt-8 text-slate-400 font-black text-[10px] uppercase tracking-[0.3em]">Vazgeç</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DriverPage;